import axios from './http';
import { CancelTokenSource } from 'axios';
import { TextDto, UpsertTextDto } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/texts`;

export const getAllNonDeletedTexts = (source: CancelTokenSource): Promise<Array<TextDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchTexts = (query: String,
                               source: CancelTokenSource): Promise<Array<TextDto>> => {
  return axios
      .get(`${apiUri}`,{params: {query: query}, cancelToken: source.token})
      .then(response => response.data);
};

export const findTextById = (id: number, source: CancelTokenSource): Promise<UpsertTextDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteText = (id: number, source: CancelTokenSource): Promise<TextDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addText = (upsertTextDto: Partial<UpsertTextDto>, source: CancelTokenSource): Promise<TextDto> => {
  return axios
      .post(apiUri, upsertTextDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editText = (id: number, upsertTextDto: Partial<UpsertTextDto>,
                         source: CancelTokenSource): Promise<TextDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertTextDto, {cancelToken: source.token})
      .then(response => response.data);
};
